import { useHistory } from '@bbkShared/react-router';
import { LogInPaths } from '@bbkAdminComponents/log-in-flow/log-in-paths';
import { encodeObjectForQuery } from '@bbkAdminRedux/rtkq/rtkq-utils';

export const useSignInRedirect = () => {
  const history = useHistory();

  return {
    url:
      LogInPaths.signIn +
      encodeObjectForQuery({
        redirectUri: history.location.pathname + history.location.search,
      }),
  };
};
